import { AnalyticsEventType, SmsResendScenario } from 'b24network.component.useractions';
import { SharedAnalytics, LoginValidator } from 'b24network.vue.cross-scenario-shared-js';

export class Analytics
{
	static emitLoginNotFoundEvent(isPhoneLogin: boolean): void
	{
		const eventType = isPhoneLogin
			? AnalyticsEventType.ERROR_PHONE_NOT_FOUND
			: AnalyticsEventType.ERROR_EMAIL_NOT_FOUND
		;

		SharedAnalytics.getAnalyticsInstance()?.registerEvent(eventType);
	}

	static emitSocialServiceEmailErrorEvent(): void
	{
		SharedAnalytics.getAnalyticsInstance()?.registerEvent(
			AnalyticsEventType.ERROR_USE_SOCSERV_EMAIL,
		);
	}

	static emitQrCodeAuthSuccessEvent(targetUrl: ?string): void
	{
		const params = {};
		if (targetUrl)
		{
			params.portal_name = (new URL(targetUrl)).hostname;
		}

		SharedAnalytics.getAnalyticsInstance()?.registerEvent(
			AnalyticsEventType.QR_CODE_AUTH_SUCCESS,
			params,
		);
	}

	static emitShowLoginEnterPageEvent(): void
	{
		const analyticsInstance = SharedAnalytics.getAnalyticsInstance();

		if (analyticsInstance)
		{
			analyticsInstance.registerEvent(
				AnalyticsEventType.SHOW_AUTH_ENTER_LOGIN_PAGE,
				{
					...analyticsInstance.getUtmParams(),
				},
			);
		}
	}

	static emitShowPasswordEnterPageEvent(): void
	{
		SharedAnalytics.getAnalyticsInstance()?.registerEvent(
			AnalyticsEventType.SHOW_ENTER_PASSWORD_PAGE,
		);
	}

	static emitShowQrCodeEvent(): void
	{
		SharedAnalytics.getAnalyticsInstance()?.registerEvent(
			AnalyticsEventType.SHOW_QR_CODE_AUTH_PAGE,
		);
	}

	static emitShowSetNewPasswordPageEvent(): void
	{
		SharedAnalytics.getAnalyticsInstance()?.registerEvent(
			AnalyticsEventType.SHOW_SET_NEW_PASSWORD_PAGE,
		);
	}

	static emitShowEnterSmsCodePageEvent(): void
	{
		SharedAnalytics.getAnalyticsInstance()?.registerEvent(
			AnalyticsEventType.SHOW_ENTER_SMS_CODE_PAGE,
		);
	}

	static emitShowExistingAccountsListPageEvent(): void
	{
		SharedAnalytics.getAnalyticsInstance()?.registerEvent(
			AnalyticsEventType.SHOW_AUTH_CHOOSE_EXISTED_PAGE,
		);
	}

	static emitWrongPasswordErrorEvent(): void
	{
		SharedAnalytics.getAnalyticsInstance()?.registerEvent(AnalyticsEventType.ERROR_WRONG_PASSWORD);
	}

	static emitShowForgotPasswordRestorePageEvent(networkUserId): void
	{
		SharedAnalytics.getAnalyticsInstance()?.registerEvent(
			AnalyticsEventType.SHOW_FORGOT_PASSWORD_PAGE,
			{
				network_user_id: networkUserId,
			},
		);
	}

	static emitSendEmailRestorePasswordEvent(networkUserId): void
	{
		SharedAnalytics.getAnalyticsInstance()?.registerEvent(
			AnalyticsEventType.SEND_EMAIL_RESTORE_PASSWORD,
			{
				network_user_id: networkUserId,
			},
		);
	}

	static emitSmsResendClick(): void
	{
		try
		{
			SharedAnalytics.getAnalyticsInstance()?.registerEvent(
				AnalyticsEventType.SMS_RESEND_CLICK,
				{
					scenario: SmsResendScenario.PASSWORD_RESTORE,
				},
			)?.catch(() => {
				// Analytics errors must not block confirmation code resend.
			});
		}
		catch
		{
			// Analytics errors must not block confirmation code resend.
		}
	}

	static emitShowUserNotExistsOnPortalPage(): void
	{
		SharedAnalytics.getAnalyticsInstance()?.registerEvent(
			AnalyticsEventType.SHOW_NOT_YOUR_PORTAL_PAGE,
		);
	}

	static emitClickNotYourPortalGoToPortalList(): void
	{
		SharedAnalytics.getAnalyticsInstance()?.registerEvent(
			AnalyticsEventType.CLICK_NOT_YOUR_PORTAL_GO_TO_PORTAL_LIST,
		);
	}

	static emitClickOnMobileAppIcon(isIosApp: boolean): void
	{
		const eventType = isIosApp === true
			? AnalyticsEventType.CLICK_ON_IOS_MOBILE_APP_ICON
			: AnalyticsEventType.CLICK_ON_ANDROID_MOBILE_APP_ICON
		;

		SharedAnalytics.getAnalyticsInstance()?.registerEvent(eventType);
	}

	static emitCreateB24ButtonClick(): void
	{
		SharedAnalytics.getAnalyticsInstance()?.registerEvent(
			AnalyticsEventType.CLICK_CREATE_B24_BUTTON,
		);
	}

	static emitOnAuthorizationLoginEntered(login: string, isSso: boolean = false): void
	{
		let loginType = 'unknown';

		if (LoginValidator.isPhoneLogin(login))
		{
			loginType = 'phone';
		}
		else if (LoginValidator.isEmailLogin(login))
		{
			loginType = isSso ? 'sso_email' : 'email';
		}

		SharedAnalytics.getAnalyticsInstance()?.registerEvent(
			AnalyticsEventType.AUTHORIZATION_LOGIN_ENTERED,
			{
				login_type: loginType,
			},
		);
	}

	static emitOldBitrixCaptchaShown(): void
	{
		SharedAnalytics.getAnalyticsInstance().registerEvent(
			AnalyticsEventType.CAPTCHA_SHOWED_OLD_BITRIX,
		);
	}

	static emitPasswordRestoreEmailSentPageShown(): void
	{
		SharedAnalytics.getAnalyticsInstance().registerEvent(
			AnalyticsEventType.PASSWORD_RESTORE_MAIL_SENT_PAGE,
		);
	}

	static emitShowLoginPopupBox(): void
	{
		SharedAnalytics.getAnalyticsInstance().registerEvent(
			AnalyticsEventType.LOGIN_POPUP_BOX_SHOW,
		);
	}

	static emitClickLoginPopupBox(): void
	{
		SharedAnalytics.getAnalyticsInstance().registerEvent(
			AnalyticsEventType.LOGIN_POPUP_BOX_CLICK,
		);
	}

	static emitRedirectLoginPopupBox(): void
	{
		SharedAnalytics.getAnalyticsInstance().registerEvent(
			AnalyticsEventType.LOGIN_POPUP_BOX_REDIRECT,
		);
	}
}
